import React from 'react';
import PropTypes from 'prop-types';
import { Select as AntSelect } from 'antd';
import cn from '../utils/cn';
import { CaretDownIcon } from '../icons';
import styles from './Select.module.css';

const Select = React.forwardRef(function Select(
  { options, value, onChange, className, ...rest },
  ref
) {
  return (
    <AntSelect
      ref={ref}
      className={cn(styles.root, className)}
      popupClassName={styles.popup}
      value={value}
      onChange={onChange}
      options={options}
      suffixIcon={<CaretDownIcon size={6} aria-hidden='true' />}
      {...rest}
    />
  );
});

Select.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })
  ),
  value: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string
};

export default Select;
